import { omit } from 'lodash';
import { v4 as generateUuid } from "uuid";

import ActionTypes from 'core/actions/actionTypes';
import initialState from 'core/reducers/initialState';
import { arrayMove } from 'core/util/ArrayUtils';
import { iDef, nDef } from 'core/util/TypeUtils';

/**
 * @overview: Reducer for actions related to panel, view, and panel scoped view
 * configuration. More documentation coming soon.
 * @author joe
 */

export default function configReducer(state = initialState.config, action: any) {
	switch (action.type) {

		// replace
		case ActionTypes.CONFIG_LOAD_SUCCESS:

			return {...action.config, key: action.key};

		case ActionTypes.CONFIG_GLOBAL_ADD:

			return {...state, global: action.config};

		case ActionTypes.CONFIG_PANEL_ADD:

			return {...state, panels: {...state.panels, [action.instance]: action.config}};

		case ActionTypes.CONFIG_PANEL_REMOVE:

			return {...state, panels: {...omit(state.panels, action.instance)}};

		case ActionTypes.CONFIG_VIEW_ADD:

			return {...state, views: {...state.views, [action.viewId]: {...state.views[action.viewId] || {}, [action.instance]: action.config }}};

		case ActionTypes.CONFIG_VIEW_REMOVE:

			return {...state, views: {...state.views, [action.viewId]: {...state.views[action.viewId] ? omit(state.views[action.viewId], action.instance) : {}}}};

		case ActionTypes.CONFIG_VIEW_CLONE:
			const source = state.views[action.viewId][action.variant];
			const newInstance = generateUuid();

			return {...state, views: {...state.views, [action.viewId]: {...[action.viewId], [newInstance]: source}}};

		case ActionTypes.CONFIG_PANEL_VIEW_ADD:

			return {...state, panelViews: {...state.panelViews, [action.instance]: action.viewInstance}};

		case ActionTypes.CONFIG_PANEL_VIEW_REMOVE:

			return {...state, panelViews: omit(state.panelViews, action.instance)};

		case ActionTypes.CONFIG_PANEL_BORDER_TOGGLE:

			const panelConfg = {...state.panels[action.targetInstance], __border: action.enabled, __title: action.title};

			return {...state, panels: {...state.panels, [action.targetInstance]: panelConfg}};

		case ActionTypes.LAYOUT_PANEL_MOVE:

			// disallow if child is already present
			if(state.panels[action.targetInstance].children.indexOf(action.panelInstance) >= 0) {
				return state;
			}

			let formInstance;
			let fromConfig = {};

			Object.entries(state.panels).forEach(([k, value]: [string, object]) => {
				const children = (value as any).children;

				if(iDef(children) && (children.indexOf(action.panelInstance) >= 0)) {
					formInstance = k;
					fromConfig = {...value, children: children.filter((c) => c !== action.panelInstance)};
					return false;
				}
			});

			const newChildren = state.panels[action.targetInstance].children;

			const toConfig = {...state.panels[action.targetInstance], children: [...newChildren, action.panelInstance]};

			return {...state, panels: {...state.panels, [formInstance]: fromConfig, [action.targetInstance]: toConfig}};

		case ActionTypes.LAYOUT_PANEL_SORT:

			const config = state.panels[action.targetInstance];

			const newConfig = {...config, children: [...arrayMove([...config.children], action.dragIndex, action.hoverIndex)]};

			return {...state, panels: {...state.panels, [action.targetInstance]: newConfig}};

		case ActionTypes.CONFIG_PROPERTY_ADD:
			const { scope, group, field } = action.reference;

			return {
				...state,
				[scope]: {
					...state[scope],
					[group]: {
						...state[scope][group],
						[field]: action.record
					}
				}
			};

		case ActionTypes.CONFIG_CONDITION_ADD:
			return {
				...state,
				conditions: {
					...state.conditions || {},
					[action.uuid]: action.externalId
				}
			};

		case ActionTypes.CONFIG_CONDITION_REMOVE:
			return {
				...state,
				conditions: omit(state.conditions || {}, action.uuid)
			};

		case ActionTypes.CONFIG_CONTEXT_PROPERTIES_SUCCESS:
			return {
				...state,
				contextProperties: {...action.properties}
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/config/configReducer.ts